import { command, computed, state } from 'ccstate'
import { currentRoute$ } from './router/routeRegistry'
import { navigateInReact$ } from './router/navigate'
import { logger } from '../../common/infra/log'
import { authClient } from '../../common/infra/authClient'
import *  as sentryStates from './sentryClient'

const L = logger('authStates')

export const supabaseSessionDirty$ = state(1)

export const supabaseSession$ = computed(async (get) => {
  get(supabaseSessionDirty$)
  const session = await authClient.getSession()
  return session
})

export const supabaseCurrentUser$ = computed(async (get) => {
  const session = await get(supabaseSession$)
  if (!session) {
    return {
      isLoggedIn: false,
      email: '',
      avatarUrl: '',
      __is_from_server: true
    }
  }
  return {
    isLoggedIn: true,
    email: session.user.email,
    avatarUrl: session.user.user_metadata?.avatar_url,
    __is_from_server: true
  }
})

export const initAuthStates$ = command(({get, set}) => {
  authClient.onAuthStateChange(async (event, session) => {
    L.debug(L.fmt`onAuthStateChange ${event}`)
    const isLoggedIn = session?.access_token
    if (isLoggedIn && get(currentRoute$)?.path === '/login') {
      set(supabaseSessionDirty$, val => val + 1)
      set(navigateInReact$, '/')
    } else if (!isLoggedIn && get(currentRoute$)?.path !== '/login') {
      set(supabaseSessionDirty$, val => val + 1)
      set(navigateInReact$, '/login')
    }
    sentryStates.afterAuth(session?.user)
  })
})